module.exports = "/images/protected-3-year-agent.png?b472cb611bd79ab6c835949e0935e3dc";